/**
 * @file: 用户 request
 */
import Cookies from 'js-cookie';
import ksBridge from '@ks/ks-bridge';
import { IGetFaceIdStatus } from '@/schemas/user';
import { IM_COMMON_CONFIG } from '@/configs/constants';
import { request } from './request';

import { ApiConfigs, Response } from '../schemas/service';

const api: ApiConfigs = {
  queryUserInfo: {
    url: '/health/api/v1/consult/simpleUserInfo',
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/consult/simpleUserInfo',
    method: 'POST'
  },
  //  开服务申请条件判断接口
  getUserBindingInforAndList: {
    url: '/health/api/v1/doctor/getDoctorApplyCondition',
    method: 'GET'
  },
  uploadPics: {
    url: '/health/api/v1/doctor/picUpload',
    method: 'POST'
  },
  getFaceIdStatus: {
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/doctorEnd/workbench/entrance',
    url: '/health/api/v1/doctorEnd/workbench/entrance',
    method: 'GET'
  },
  checkFaceIdToken: {
    url: '/health/api/v1/doctorEnd/workbench/antispamCheck',
    method: 'GET'
  },
  // 医生开药医师引导弹窗显示接口
  getGuidancePopup: {
    url: '/health/api/v1/doctorEnd/workbench/guidancePopup',
    method: 'GET'
  },
  // 创建快捷分组
  createQuickReply: {
    url: '/health/api/v1/doctorEnd/workbench/createQuickReply',
    method: 'POST'
  }
};

const user = {
  async getUserInfo() {
    try {
      const response: Response = await request(
        api.queryUserInfo,
        undefined,
        undefined,
        { hideToast: true }
      );
      let { result } = response;
      const { userAgreeProtocol } = result;
      result = {
        ...result,
        agreeProtocol: userAgreeProtocol
      };
      // 用于dev-diy发送cookie时使用,其他地方未使用
      if (result.doctor) {
        Cookies.set('doctorFlag', '2');
      } else {
        Cookies.set('doctorFlag', '1');
      }
      // 页面埋点需要医生类型，除此之外不应该用这个值来做任何的逻辑判断
      // 需要在页面中使用jobType的话，应该用rematch中存储的值
      if (result.jobType) {
        sessionStorage.setItem('jobType', result.jobType);
      }
      return result;
    } catch (error) {
      // TODO
      return Promise.reject(error);
    }
  },

  // 开服务申请条件及已开通付服务医生列表
  async getUserBindingInforAndList() {
    try {
      const response: Response = await request(
        api.getUserBindingInforAndList,
        undefined,
        undefined,
        { hideGlobalLoading: false }
      );
      const { result } = response;
      return result || Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async uploadPics(base64s) {
    try {
      const {
        result
      }: Response<Array<{
        picId: string;
        picUrl: string;
      }>> = await request(api.uploadPics, undefined, {
        base64s
      });
      if (result) {
        return result;
      }
      return [];
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async getKlinkToken() {
    const KEY_SESSION = 'health_klink_st';

    try {
      // 获取session缓存数据
      const klinkInSession = sessionStorage.getItem(KEY_SESSION);
      if (klinkInSession) {
        const ret = JSON.parse(klinkInSession);
        return ret;
      }
      // 无session缓存数据
      const kLinkHost =
        process.env.NX_APP_ENV === 'dev' || process.env.NX_APP_ENV === 'staging'
          ? 'https://ksid.test.gifshow.com/'
          : 'https://id.kuaishou.com/';
      const res = await fetch(`${kLinkHost}rest/infra/getKlinkToken`, {
        credentials: 'include'
      });
      const result = await res.json();
      if (result.result === 1) {
        const ret = {
          serviceToken: result['kuaishou.klink.h5_st'],
          ssecurity: result.ssecurity
        };
        sessionStorage.setItem(KEY_SESSION, JSON.stringify(ret));
        return ret;
      }
      return Promise.reject();
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async getFaceIdStatus() {
    try {
      const response: Response<IGetFaceIdStatus> = await request(
        api.getFaceIdStatus,
        undefined,
        undefined
      );
      const { result } = response;

      if (result != null) {
        return result;
      }

      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async checkFaceIdToken(verifyToken: string, verifyType: number) {
    try {
      const response: Response<boolean> = await request(
        api.checkFaceIdToken,
        { verifyToken, verifyType },
        undefined,
        { hideGlobalLoading: false }
      );
      const { result } = response;

      if (result != null) {
        return result;
      }

      return Promise.reject();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getGuidancePopup() {
    try {
      const response: Response<number> = await request(
        api.getGuidancePopup,
        undefined,
        undefined,
        { hideToast: true }
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async createQuickReply() {
    try {
      const { sid } = IM_COMMON_CONFIG;
      return new Promise((resolve) => {
        ksBridge.getSidToken({
          sid,
          forceRefresh: true,
          success: async (ret) => {
            if (ret?.token) {
              const KEY = 'kuaishou.health_channel.login_st';
              Cookies.remove(KEY);
              Cookies.set(KEY, ret.token);
              if (Cookies.get(KEY)) {
                const response: Response = await request(
                  api.createQuickReply,
                  undefined,
                  undefined,
                  { hideToast: true }
                );
                const { result } = response;
                resolve(result);
              }
            }
          },
          fail: (err) => {
            //
          }
        });
      });
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default user;
